import UploadNotas from "./components/UploadNotas";
import AuthProvider from "./components/AuthProvider";
import React from "react";

export default function App() {
  return (
    <AuthProvider>
      <UploadNotas />
    </AuthProvider>
  );
}
